jQuery(document).ready(function($) {
  // -----------------------
  // Sticky header
  // -----------------------
	var sticky = $('.site-header');
    if( $(window).scrollTop() >= 10 ) {
		sticky.addClass('fixed-header');
    } else {
    	sticky.removeClass('fixed-header');
    }
  
    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if (scroll >= 10){
        sticky.addClass('fixed-header');
      } else {
          sticky.removeClass('fixed-header');
      }
    });
  
  	//-----------------------
  	// Smooth scroll
  	// ------------------------
  	$('.mouse, .hero__btn-home').on('click',function (e) {
	    e.preventDefault();
	    var target = $(this).parents('.shopify-section').next();
	    var $target = $(target);
	    $('html, body').stop().animate({
	        'scrollTop': $target.offset().top - 80
	    }, 1000, 'swing', function () {
	        // window.location.hash = target;
	    });
	});
  
    $(document).on('click', 'a[href^="#"]:not(.hero__btn-home)', function (event) {
      event.preventDefault();
       if ($(window).width() < 767) {
         var headerHeight = $('.site-header').outerHeight(!0);
       } else {
         var headerHeight = 25;
       }
     
      $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top - headerHeight
      }, 500, 'swing');
  });

  // if (location.hash){
  //   var id = $(location.hash);
  //   }
  //   $(window).load(function() {
  //     if (location.hash){
  //       $('html,body').animate({scrollTop: id.offset().top -80}, 500)
  //     };
  //    });


   $('.mobile-nav__item a[href^="#"]').on('click', function () {
      $('.mobile-nav--close').trigger('click');
  });

  
});


(function($){
        $(window).on("load",function(){
            $(".content").mCustomScrollbar({
              axis:"x"
            });
        });
    })(jQuery);


function adjustAnchor(){
   var $anchor = $(':target'),
                fixedElementHeight = $('.site-header').outerHeight(true) + 25;
            if ($anchor.length > 0) {
                $('html, body').animate({
                   scrollTop: $(window.location.hash).offset().top - fixedElementHeight
                }, 200);
            }
  
}

$( window ).on("load", function() {
    adjustAnchor();
  if ($(window).width() > 1024) {
    setTimeout(adjustAnchor, 500)
}
});

